import { Application } from "@hotwired/stimulus"

const application = Application.start()

import { Alert, Autosave, ColorPreview, Dropdown, Modal, Tabs, Popover, Toggle, Slideover } from "tailwindcss-stimulus-components"
application.register('alert', Alert)
application.register('autosave', Autosave)
application.register('color-preview', ColorPreview)
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('popover', Popover)
application.register('slideover', Slideover)
application.register('toggle', Toggle)

// Register custom controllers
import TeamTabsController from "./team_tabs_controller"
application.register('team-tabs', TeamTabsController)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
